import Styles from './Sidebar.module.scss'
import { Item } from './Item'
import { useImagePickerContext } from '../ImagePickerContext'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { GenerateImageModal } from 'components/GenerateImageModal/GenerateImageModal'
import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useUploadsProject } from 'hooks/useUploadsProject'
import { useConfirm } from '../AIGeneration/useConfirm'

export const Sidebar = () => {
  const { openModal, closeModal } = useModals()
  const isNewDesktopImageGen = useFlipperFlag('new_desktop_image_gen')
  const context = useImagePickerContext()
  const { hiddenProviders, provider, setProvider } = context
  const { data } = useBrandKits({
    select: (data) => data.filter((brandKit) => brandKit.media_files.length > 0),
    cacheTime: 1000 * 60 * 5,
  })
  const workspaceId = useCurrentWorkspaceId()
  const uploadsProject = useUploadsProject(workspaceId)?.data?.project
  const { confirm } = useConfirm()

  return (
    <div className={Styles.sidebar}>
      {!hiddenProviders.has('ai') && (
        <Item
          label="Generate"
          icon="https://res.cloudinary.com/almanac/image/upload/v1717354875/blaze_assets/Image%20Icons/ai_fxf1ts.png"
          isActive={provider === 'ai'}
          onPress={() => {
            if (isNewDesktopImageGen) {
              if (!uploadsProject) return

              openModal(GenerateImageModal, {
                onConfirm: (img) => {
                  confirm([img])
                  closeModal()
                },
              })
            } else {
              setProvider('ai')
            }
          }}
        />
      )}
      {!hiddenProviders.has('uploads') && (
        <Item
          label="Upload"
          icon="https://res.cloudinary.com/almanac/image/upload/v1717162590/blaze_assets/Image%20Icons/mediaUpload_nqrffm.png"
          isActive={provider === 'uploads'}
          onPress={() => setProvider('uploads')}
        />
      )}
      {!hiddenProviders.has('link') && (
        <Item
          label="Add file link"
          icon="https://res.cloudinary.com/almanac/image/upload/v1717162590/blaze_assets/Image%20Icons/addMediaLink_eudm5m.png"
          isActive={provider === 'link'}
          onPress={() => setProvider('link')}
        />
      )}
      {!hiddenProviders.has('stock') && (
        <Item
          label="Stock images"
          icon="https://res.cloudinary.com/almanac/image/upload/v1719567564/blaze_assets/Image%20Icons/stock_p2fw2u.png"
          isActive={provider === 'stock'}
          onPress={() => setProvider('stock')}
        />
      )}
      {!hiddenProviders.has('gifs') && (
        <Item
          label="GIFs"
          icon="https://res.cloudinary.com/almanac/image/upload/v1717162590/blaze_assets/Image%20Icons/giphy_uaigq4.png"
          isActive={provider === 'gifs'}
          onPress={() => setProvider('gifs')}
        />
      )}
      {!hiddenProviders.has('brandKits') && (data || []).length > 0 && (
        <Item
          label="Brand Kits"
          icon="https://res.cloudinary.com/almanac/image/upload/c_thumb,w_25/v1722952135/blaze_assets/hd_icons/brand_ruojtv.png"
          isActive={provider === 'brandKits'}
          onPress={() => setProvider('brandKits')}
        />
      )}
    </div>
  )
}
